import { useState } from 'react';
import PropTypes from 'prop-types';

import { formatMetric, formatNumber } from '../../../../utils/util';

import Image from '../../image/Image';
import ImageCarousel from '../../image-carousel/ImageCarousel';
import Button from '../../button/Button';

import './contract-offer.scss';

const ContractOffer = ({ product, onClose }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(undefined);

  const calculateTotalPrice = () => {
    const totalProductUnits = product.availableQuantity / product.productUnit;
    const totalPrice = totalProductUnits * product.price;

    return totalPrice;
  };

  return (
    <>
      <div className="contract-offer">
        <p className="contract-offer__title">Listing Offer</p>
        <div className="contract-offer__grid">
          <div className="contract-offer__grid-item">
            <p>Product Name</p>
            <p>{product.name}</p>
          </div>
          <div className="contract-offer__grid-item">
            <p>Minimum Order Quantity</p>
            {product.minimumOrderQuantity ? (
              <p>
                {formatNumber(product.minimumOrderQuantity)}{' '}
                {formatMetric(product.productUnitMetric, product.minimumOrderQuantity)}
              </p>
            ) : (
              <p>-</p>
            )}
          </div>
          <div className="contract-offer__grid-item">
            <p>Product Unit</p>
            <p>
              {formatNumber(product.productUnit)} {formatMetric(product.productUnitMetric, product.productUnit)}
            </p>
          </div>
          <div className="contract-offer__grid-item">
            <p>Price per Product Unit</p>
            <p>
              {formatNumber(product.price)}
              <sup>USD</sup>
            </p>
          </div>
          <div className="contract-offer__grid-item">
            <p>Total Amount of Product</p>
            <p>
              {formatNumber(product.availableQuantity)}{' '}
              {formatMetric(product.productUnitMetric, product.availableQuantity)}
            </p>
          </div>
          <div className="contract-offer__grid-item">
            <p>Total Price</p>
            <p>
              {formatNumber(calculateTotalPrice())}
              <sup>USD</sup>
            </p>
          </div>
          <div className="contract-offer__grid-item">
            <p>Location City</p>
            <p>{product.city}</p>
          </div>
          <div className="contract-offer__grid-item">
            <p>Location Country</p>
            <p>{product.country}</p>
          </div>
        </div>
        {product?.photos?.length > 0 && (
          <div className="contract-offer__photos">
            <p>Photos</p>
            <div>
              {product.photos.map((photo, index) => (
                <Image
                  key={index}
                  className="contract-offer__photo"
                  externalReference={photo}
                  alt=""
                  onClick={() => setSelectedImageIndex(index)}
                />
              ))}
            </div>
          </div>
        )}

        {product.additionalInformation && (
          <div className="contract-offer__additional-info">
            <p>Additional Information</p>
            <p>{product.additionalInformation}</p>
          </div>
        )}

        <div className="contract-offer__button">
          <Button onClick={onClose}>Close</Button>
        </div>
      </div>

      {selectedImageIndex !== undefined && (
        <ImageCarousel images={product?.photos} startIndex={selectedImageIndex} setStartIndex={setSelectedImageIndex} />
      )}
    </>
  );
};

ContractOffer.propTypes = {
  product: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ContractOffer;
